import { DatePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { lucideArrowRight, lucideLink2, lucideLink2Off } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';

import { Activité } from '../../../../models/activité.model';

@Component({
  selector: 'app-activite-card',
  imports: [HlmCardImports, HlmTooltipImports, HlmButtonImports, HlmIconImports, DatePipe],
  templateUrl: './activite-card.component.html',
  providers: [provideIcons({ lucideLink2, lucideLink2Off, lucideArrowRight })],
})
export class ActiviteCardComponent {
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);

  readonly activite = input.required<Activité>();
  readonly idSequence = input.required<string>();

  navigateToDetailsActivite(idActivité: string) {
    this.#router.navigate(['../..', idActivité], {
      relativeTo: this.#route,
      queryParams: { idSequence: this.idSequence() },
    });
  }
}
